var React = require('react');

function ShowMoreSolid (props) {
    return React.createElement("svg",props,React.createElement("g",{"transform":"translate(-45.648 -184.66)"},React.createElement("path",{"d":"m48.149 186.87-2.0722 2.0722h-0.29607v-0.29607l1.7761-1.7762-1.7761-1.7761v-0.29607h0.29607z","fill":"#179dc6","stroke":"#189dc6","strokeLinejoin":"round","strokeWidth":".26458","data-name":"Контур 374288"})));
}

ShowMoreSolid.defaultProps = {"width":"2.6329mm","height":"4.409mm","version":"1.1","viewBox":"0 0 2.6329 4.409"};

module.exports = ShowMoreSolid;

ShowMoreSolid.default = ShowMoreSolid;
